import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 25,
	viewBox: "0 0 32 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .8,
		d: "M12.8 0H3.2C1.44 0 0.016 1.40625 0.016 3.125L0 21.875C0 23.5938 1.44 25 3.2 25H28.8C30.56 25 32 23.5938 32 21.875V6.25C32 4.53125 30.56 3.125 28.8 3.125H16L12.8 0Z",
		fill: "#6565EC"
	})
});
export { SvgFolder as ReactComponent };
